'use client';

import { usePathname } from 'next/navigation';
import { FEATURED_BRANDS_PATH } from './filters';
import { denormalizeFilterName } from './normalizeFilterName';

export const useFeaturedBrand = (): string | null => {
    const pathname = usePathname();
    const isFeaturedBrandPage = pathname?.includes(FEATURED_BRANDS_PATH);

    if (isFeaturedBrandPage) {
        return denormalizeFilterName(pathname?.split('/')[2] ?? '');
    }

    return null;
};
